
const getCurrectQueryStrong = (queryString) => {
  if (queryString[0] === "?"){
    return queryString.replace("?", "")
  }
  return queryString
}

export const getAcyCloudUrl = (lang = 'en') => {
  let baseUrl = 'https://www.acy.cloud';
  const host = window.location.host;
  const pageUrl = window.location.href
  let queryString = '';
  if (window && window.location.search) {
      const currectQueryString = getCurrectQueryStrong(window.location.search);
      queryString = `?campaign=spin-win&${currectQueryString}&url=${pageUrl}&next=/create-account/select-account-type&locale=${lang}`;
  } else {
      queryString = `?campaign=spin-win&url=${pageUrl}&next=/create-account/select-account-type&locale=${lang}`;
  } 
  if(process.env.REACT_APP_DOMAIN === 'acycn.com' || host === "acyasiavn.com"){
      baseUrl = 'https://acycn.cloud'
  }
  return `${baseUrl}/open-live-account${queryString}`
}

export const handleAccount = (lang = 'en') => {
  return () => window.open(getAcyCloudUrl(lang), '_blank');
}